var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#1554FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8906 2.36188L8.07259 6.17988C7.87531 6.37688 7.74077 6.62787 7.68592 6.90122L7.33325 8.66655L9.09859 8.31322C9.37192 8.25855 9.62259 8.12455 9.81992 7.92722L13.6379 4.10922C13.7527 3.99449 13.8437 3.85828 13.9058 3.70838C13.9678 3.55847 13.9998 3.39781 13.9998 3.23555C13.9998 3.0733 13.9678 2.91263 13.9058 2.76273C13.8437 2.61282 13.7527 2.47662 13.6379 2.36188C13.5232 2.24715 13.387 2.15614 13.2371 2.09405C13.0872 2.03196 12.9265 2 12.7643 2C12.602 2 12.4413 2.03196 12.2914 2.09405C12.1415 2.15614 12.0053 2.24715 11.8906 2.36188Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 9.99967V11.9997C12.6666 12.3533 12.5262 12.6924 12.2761 12.9425C12.0261 13.1925 11.6869 13.333 11.3333 13.333H3.99996C3.64634 13.333 3.3072 13.1925 3.05715 12.9425C2.8071 12.6924 2.66663 12.3533 2.66663 11.9997V4.66634C2.66663 4.31272 2.8071 3.97358 3.05715 3.72353C3.3072 3.47348 3.64634 3.33301 3.99996 3.33301H5.99996",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNoBg);
export default __webpack_public_path__ + "static/media/edit-no-bg.34e75b8612fcfbe0dee901baec542a7e.svg";
export { ForwardRef as ReactComponent };